query GetAmendedPledge($id: ID!) {
  amendedPledge(id: $id) {
    id
    userId
    firstName
    surname
    createdDate
    fullHomeAddress
    companyName
    currentPercentage
    dateSigned
    countersigned
    currentPercentage
    originalPercentage
    originalDateSigned
    countersignatureUrl
    signed
  }
}
